import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ThemedRemoveCircleOutlineIcon } from "assets/CXFIcons/Actions";
import { updateSharedConnector as updateSharedConnectorAction } from "redux/actions/portal/connectorsActionCreator";
import { updateSharedConnector } from "api/ComponentsApi";

const options = {
  status: [
    { value: "owner", label: "Owner" },
    { value: "editor", label: "Editor" },
    { value: "readOnly", label: "Access Only" },
  ],
};

export const UserRole = ({ user, handleSetUserToBeRemoved, isAllowedToShare, connector, isReadOnlyAccess, canEditConnector }) => {
  const [accessType, setAccessType] = useState(options.status[0]);
  const [isUpdatingAccessType, setIsUpdatingAccessType] = useState(false);
  const { sharedConnectors } = useSelector((store) => store.portal.connectors);
  const dispatch = useDispatch();

  const getSharedConnector = () => {
    return sharedConnectors.find(
      (sharedConnector) =>
        sharedConnector.shared_user_id === user.auth0_id &&
        sharedConnector.connector_id === connector.id
    );
  };

  const handleUpdateUserAccessType = async (newValue) => {
    if (isUpdatingAccessType || !isAllowedToShare || accessType.value === "owner") return;

    setIsUpdatingAccessType(true);

    const input = {
      ...getSharedConnector(),
      access_type: newValue.value,
    };

    const result = await updateSharedConnector(input);

    setIsUpdatingAccessType(false);

    if (result?.isSuccessful) {
      toast.success("User access type successfully updated");

      dispatch(updateSharedConnectorAction(input));
      setAccessType(newValue);
    } else {
      toast.error("Something went wrong, Please try again");
    }
  };

  useEffect(() => {
    if (user.auth0_id === connector.created_by_id) {
      setAccessType(options.status.find((status) => status.value === "owner"));
      return;
    }

    const sharedConnectorUser = sharedConnectors.find(
      (sharedConnector) =>
        sharedConnector.shared_user_id === user.auth0_id &&
        sharedConnector.connector_id === connector.id
    );

    if (sharedConnectorUser) {
      setAccessType(
        options.status.find((status) => status.value === sharedConnectorUser.access_type) ??
          options.status[2]
      );
    }
  }, [sharedConnectors, user.auth0_id, connector.id, connector.created_by_id]);

  return (
    <SoftBox>
      <SoftBox
        sx={{
          alignItems: "center",
          display: "flex",
        }}
      >
        <SoftSelect
          className="flow-user-select"
          placeholder="Filter Status"
          options={
          options.status
            .filter((status) => status.value !== "owner")
            .sort((a, b) => a.label.localeCompare(b.label))
          }
          hideSelectedOptions={false}
          onChange={handleUpdateUserAccessType}
          value={accessType}
          isDisabled={
            accessType.value === "owner" ||
            user.auth0_id === connector.created_by_id ||
            isReadOnlyAccess ||
            !canEditConnector
          }
        />
        {user.auth0_id !== connector.created_by_id && !isReadOnlyAccess && canEditConnector && (
          <button
            className="flow-user-remove"
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              flexShrink: 0,
            }}
            onClick={() => handleSetUserToBeRemoved(user)}
          >
            <ThemedRemoveCircleOutlineIcon
              fontSize="medium"
              width="32px"
              height="32px"
              sx={{ cursor: "pointer" }}
            />
          </button>
        )}
      </SoftBox>
    </SoftBox>
  );
};
